import React from "react";
import {Route} from "react-router-dom";

import authGuard from "./authGuard";

export default authGuard((props) => <Route {...props} />);